import { MUTATION_CREATE_ACCOUNT } from "./mutations"
import { GQL } from "./GQL"

export function createAccount(input: ContribAccount) {
  return GQL.request<CreateAccountResponse>(MUTATION_CREATE_ACCOUNT, { input })
}
